import { types as t } from 'mobx-state-tree';

export const JobType = t.enumeration('JobType', [
  'employee',
  'temporary',
  'intern',
  'seasonal',
  'not_specified'
]);
